import { __rest } from "tslib";
import * as React from 'react';
import Trigger from 'rc-trigger';
import classNames from 'classnames';
const getBuiltInPlacements = (dropdownMatchSelectWidth) => {
    const adjustX = typeof dropdownMatchSelectWidth !== 'number' ? 0 : 1;
    return {
        bottomLeft: {
            points: ['tl', 'bl'],
            offset: [0, 4],
            overflow: {
                adjustX,
                adjustY: 1,
            },
        },
        bottomRight: {
            points: ['tr', 'br'],
            offset: [0, 4],
            overflow: {
                adjustX,
                adjustY: 1,
            },
        },
        topLeft: {
            points: ['bl', 'tl'],
            offset: [0, -4],
            overflow: {
                adjustX,
                adjustY: 1,
            },
        },
        topRight: {
            points: ['br', 'tr'],
            offset: [0, -4],
            overflow: {
                adjustX,
                adjustY: 1,
            },
        },
    };
};
const SelectTrigger = (props, ref) => {
    const { prefixCls, disabled, visible, children, popupElement, containerWidth, animation, transitionName, dropdownStyle, dropdownClassName, direction = 'ltr', dropdownMatchSelectWidth = true, dropdownRender, dropdownAlign, getPopupContainer, empty, getTriggerDOMNode } = props, restProps = __rest(props, ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode"]);
    const dropdownPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (dropdownRender) {
        popupNode = dropdownRender(popupElement);
    }
    const builtInPlacements = React.useMemo(() => getBuiltInPlacements(dropdownMatchSelectWidth), [dropdownMatchSelectWidth]);
    const mergedTransitionName = animation ? `${dropdownPrefixCls}-${animation}` : transitionName;
    const popupRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        getPopupElement: () => popupRef.current,
    }));
    const popupStyle = Object.assign({ minWidth: containerWidth }, dropdownStyle);
    if (typeof dropdownMatchSelectWidth === 'number') {
        popupStyle.width = dropdownMatchSelectWidth;
    }
    else if (dropdownMatchSelectWidth) {
        popupStyle.width = containerWidth;
    }
    return (React.createElement(Trigger, Object.assign({}, restProps, { showAction: [], hideAction: [], popupPlacement: direction === 'rtl' ? 'bottomRight' : 'bottomLeft', builtinPlacements: builtInPlacements, prefixCls: dropdownPrefixCls, popupTransitionName: mergedTransitionName, popup: React.createElement("div", { ref: popupRef }, popupNode), popupAlign: dropdownAlign, popupVisible: visible, getPopupContainer: getPopupContainer, popupClassName: classNames(dropdownClassName, {
            [`${dropdownPrefixCls}-empty`]: empty,
        }), popupStyle: popupStyle, getTriggerDOMNode: getTriggerDOMNode }), children));
};
const RefSelectTrigger = React.forwardRef(SelectTrigger);
RefSelectTrigger.displayName = 'SelectTrigger';
export default RefSelectTrigger;
